import { render, staticRenderFns } from "./PSPDFKitContainer.vue?vue&type=template&id=f91b6dac&scoped=true"
import script from "./PSPDFKitContainer.vue?vue&type=script&lang=js"
export * from "./PSPDFKitContainer.vue?vue&type=script&lang=js"
import style0 from "./PSPDFKitContainer.vue?vue&type=style&index=0&id=f91b6dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91b6dac",
  null
  
)

export default component.exports